import { Children, FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { AccordionItem as UIAccordionItem } from "@jti/ui/components/AccordionItem/AccordionItem";

import { Placeholder } from "../Placeholder/Placeholder";

import { accordionItemInputs } from "./AccordionItem.builder";

export type AccordionBuilderProps = BuilderComponentProps<
  typeof accordionItemInputs
>;

export const AccordionItem: FC<PropsWithChildren<AccordionBuilderProps>> = ({
  children,
  title,
  id,
}) => {
  return (
    <UIAccordionItem id={`${id}${title}`} title={title}>
      {isEditing() && Children.count(children) === 0 && (
        <Placeholder>Add content here</Placeholder>
      )}
      {children}
    </UIAccordionItem>
  );
};
